import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['modalWindow']

  modalShow(event) {
    event.preventDefault()
    this.modalWindowTarget.classList.remove('hidden')
  }

  modalHidden(event) {
    event.preventDefault()
    this.modalWindowTarget.classList.add('hidden')
  }

  modalSubmit() {
    this.modalWindowTarget.classList.add('hidden')
  }
}
